module.exports = __webpack_public_path__ + "public/images/all-things-painting.3f5e438187e8f72dfdba801ed74fc8a2.jpg";